export default __webpack_public_path__ + "static/media/study-material-card.b36b0e00.svg";